module.exports = __webpack_public_path__ + "static/media/cloud-2.050d4303.png";